var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.956,24H4.044a2.5,2.5,0,0,1-2.479-2.514V6.4H16.434V21.486A2.5,2.5,0,0,1,13.956,24ZM3.913,8.8V21.6H14.087V8.8ZM18,4H0V1.333H4.5L5.785,0h6.428L13.5,1.333H18V4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete1);
export default __webpack_public_path__ + "static/media/icon-delete-1.2bdd30e9cacee152c6b1f508e6fd4c20.svg";
export { ForwardRef as ReactComponent };